import { render, staticRenderFns } from "./importPage.vue?vue&type=template&id=44ad5b8e&scoped=true"
import script from "./importPage.vue?vue&type=script&lang=js"
export * from "./importPage.vue?vue&type=script&lang=js"
import style0 from "./importPage.vue?vue&type=style&index=0&id=44ad5b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ad5b8e",
  null
  
)

export default component.exports